import React, { ComponentPropsWithoutRef, useMemo } from 'react'

import { useAppSelector } from '../../../App/Hooks/reduxHooks'
import { Select } from '../../../Common/Select'
import { Spinner } from '../../../App/Components'

export const PersonSelect = (
  props: Omit<ComponentPropsWithoutRef<typeof Select>, 'options'>,
) => {
  const persons = useAppSelector(state => state.users.list)

  const options = useMemo(() => {
    if (persons) {
      return persons.map(person => ({
        label: `${person.firstName} ${person.lastName ? person.lastName : ''}`,
        value: person.uuid,
        isParentSection: false,
      }))
    }

    return []
  }, [persons])

  if (persons.length === 0) {
    return <Spinner />
  }

  return <Select {...props} options={options} />
}
